import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const lexicon = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '操作',
            key: 'operation',
            scopedSlots: {customRender: 'operation'},
            width: 100
        },
        {
            title: '物料名称',
            dataIndex: 'materialName',
            key: 'materialName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.materialName || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '物料类型',
            dataIndex: 'materialType',
            key: 'materialType',
            scopedSlots: {
                // filterDropdown: 'filterType',
                // filterIcon: 'filterIcon',
                // filtered: true,
                customRender: 'materialType'
            },
            // filteredValue: filteredInfo.materialType || [],
            // sorter: true,
            // sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '分类一',
            dataIndex: 'classOne',
            key: 'classOne',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true
            },
            filteredValue: filteredInfo.classOne || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '分类二',
            dataIndex: 'classTwo',
            key: 'classTwo',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true
            },
            filteredValue: filteredInfo.classTwo || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '物料状态',
            dataIndex: 'materialStatus',
            key: 'materialStatus',
            scopedSlots: {
                customRender: 'materialStatus'
            }
        },
        {
            title: '物料剩余数量',
            dataIndex: 'number',
            key: 'materialNumber',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.materialNumber || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '最大申领数量',
            dataIndex: 'limitQuantity',
            key: 'limitQuantity',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'limitQuantity'
            },
            filteredValue: filteredInfo.limitQuantity || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '物料位置',
            dataIndex: 'materialPlace',
            key: 'materialPlace',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.materialPlace || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },


        {
            title: '创建人',
            dataIndex: 'createBy',
            key: 'createBy',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.createBy|| [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.remark || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
    ]
}
